const state = {
  teamId: ""
};

const getters = {
  getTeamInfo(state) {
    return state;
  }
};

const mutations = {
  SET_TEAM_INFO(state, teamId) {
    state.teamId = teamId;
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
